<ng-container *transloco="let t">
  @for (eventItem of league!.events; track eventItem; let isLast = $last) {
    <div class="d-none d-md-block">
      <app-event-list-item-big [eventItem]="eventItem" [league]="league" [languages]="languages" [isLast]="isLast"
                               [countries]="countries"/>
    </div>
    <div class="d-block d-md-none" [class.mb-4]="!isLast">
      <app-event-grid-item-with-image [eventItem]="eventItem" [countries]="countries" [isOnWishList]="true"
                                            [languages]="languages" [isFinishedEvent]="eventItem.finished!"/>
    </div>
  }
</ng-container>
